<template>
	<div class="modal " id="minutes-theme-modal" tabindex="-1" role="dialog" aria-labelledby="myModalOptionLabeltheme">
		<div class="modal-dialog modal-dialog-centered" role="document">
			<div class="modal-content" style="margin-bottom:5rem;">
				<div class="modal-header">
					<h5 class="modal-title" id="myModalOptionLabeltheme">テーマ編集</h5>
					<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
				</div>
				<div class="modal-body">
					<form action="#">
						<div class="form-group">
							<input type="text" name="minutes_themename" id="minutes_themename" class="form-control" style="width: 100%;">
							<div class="invalid-feedback">入力してください</div>
						</div>
					</form>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary" name="minutes-btn-save">決定</button>
					<button type="button" class="btn btn-primary" name="minutes-btn-delete">削除</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { nanoid } from 'nanoid'
import $ from "jquery";

export default {
	props: {
	},
	data: () => ({
		
	}),
	
	created() {
		
	},
	
	methods: {
		eventStop(e) {
			  e.preventDefault();
			  e.stopPropagation();
			  e.stopImmediatePropagation();
		},
	},
	
	mounted() {
		const _self = this;
		
		$("#minutes-theme-modal").on("hidden.bs.modal", function(e) {
			$(this).find('form').trigger('reset');
			$(".minutes-active").focus();
		});

		$("#minutes-theme-modal button[name='minutes-btn-save']").on("click", function(e) {

			var $modal = $("#minutes-theme-modal");
			var $minutes_manager_area = $(".minutes-active").closest(".minutes_manager_area");
			var $textarea = $minutes_manager_area.find(".minutes_manager");
			var target =  $textarea.attr("judge_minutes");
			var agenda_detail_id = $textarea.attr("agenda_detail_id");
			var minutes_id = $textarea.attr("id");
			var isBorderCheck = true;

			var themeText = $("#minutes-theme-modal").find('[name="minutes_themename"]').val();
			if (themeText == "" || themeText == null){
				$modal.find('[name="minutes_themename"]').text("入力してください");
				$modal.find('[name="minutes_themename"]').addClass("is-invalid");
				$modal.find('[name="minutes_themename"]').focus();
			} else {
				_self.$emit('domergetheme', target, agenda_detail_id, minutes_id, isBorderCheck, themeText);
				$("#minutes-theme-modal").modal("hide");
			}
			
		});
		

		$("#minutes-theme-modal button[name='minutes-btn-delete']").on("click", function(e) {

			var $minutes_manager_area = $(".minutes-active").closest(".minutes_manager_area");
			var $textarea = $minutes_manager_area.find(".minutes_manager");
			var target =  $textarea.attr("judge_minutes");
			var agenda_detail_id = $textarea.attr("agenda_detail_id");
			var minutes_id = $textarea.attr("id");
			var isBorderCheck = false;

			var themeText = "";


			_self.$emit('domergetheme', target, agenda_detail_id, minutes_id, isBorderCheck, themeText);

			$("#minutes-theme-modal").modal("hide");
		});

		$("#minutes-theme-modal").on("show.bs.modal", function(e) {
			$(this).find('.is-invalid').removeClass("is-invalid");
			var $minutes_manager_area = $(".minutes-active").closest(".minutes_manager_area");
			var $theme = $minutes_manager_area.find(".additional-info-theme span");
			$(this).find('input[name="minutes_themename"]').val($theme.attr("theme"));
			$minutes_manager_area = $(".minutes-active");
			if ($minutes_manager_area.closest(".minutes_manager_area").find("li.minutes-border").hasClass("minutes-active-color")) {
				const $themerow = $minutes_manager_area.closest("tbody").find("#theme_"+$minutes_manager_area.attr("id"));
				$(this).find('input[name="minutes_themename"]').val(($themerow).find(".minutestheme").attr("theme"));
			}
		});

		$("#minutes-theme-modal").on("shown.bs.modal", function(e) {
			$(this).find('input[name="minutes_themename"]').focus();
		});

		$(document).on("keypress", '#minutes-theme-modal', function(e) {
			if (e.keyCode == 13) {
				_self.eventStop(e);
				$("#minutes-theme-modal button[name='minutes-btn-save']").trigger("click");
			}
		});
	}
}
</script>
<style>
.speaker-btn-area {
	display: flex;
	justify-content: end;
}

.speaker-btn-area button {
	font-size: 12px;
	height: fit-content;
}
</style>